<template>
  <div>
    <MultipleAreaBase
      v-model="inputValue"
      :tables="pageData"
      :title="$t('sale.sale_sale-register-confirm')"
      width="1166px"
      :isFooter="true"
    >
      <template #saleInfo>
        <div class="mx-5 mb-5 mt-2">
          <div class="pa-2">
            <v-row no-gutters>
              <v-col cols="8">
                <InputFormNew
                  v-model="inputData"
                  :detail="items"
                  :titleCols="inputFormStyle.titleCols"
                  :contentsCols="inputFormStyle.contentsCols"
                >
                  <template #platform>
                    <span>
                      {{ getPlatformName() }}
                    </span>
                  </template>
                </InputFormNew>
              </v-col>
            </v-row>
          </div>
        </div>
      </template>
      <template #saleDetail>
        <v-data-table
          :item-class="parentRowClass"
          :headers="headers"
          :items="combinedList"
          hide-default-footer
          :items-per-page="-1"
        >
          <!-- 配送情報 -->
          <template v-slot:[`item.customerInfo`]="{ item }">
            <div class="text-left">
              {{ item.customerName }}<br />
              {{ item.customerAddress }}<br />
              {{ item.customerPhoneNumber }}
            </div>
          </template>

          <!-- 注文メモ -->
          <template v-slot:[`item.orderNote`]="{ item }">
            <div class="text-left">
              {{ item.orderNote }}
            </div>
          </template>

          <!-- 登録商品名 -->
          <template v-slot:[`item.jdproductName`]="{ item }">
            <v-data-table
              class="child-table"
              :headers="[{ value: 'product.nameCn' }]"
              :items="item.relatedProductList"
              hide-default-header
              hide-default-footer
              no-data-text="-"
            >
              <template v-slot:[`item.product.nameCn`]="{ item }">
                <span v-if="item && item.product && item.product.nameCn">
                  {{ item.product.nameCn }}
                </span>
                <div v-else class="text-center">-</div>
              </template>
            </v-data-table>
          </template>

          <!-- 仕入先 -->
          <template v-slot:[`item.supplierName`]="{ item }">
            <v-data-table
              class="child-table"
              :headers="[{ value: 'product.supplierId' }]"
              :items="item.relatedProductList"
              hide-default-header
              hide-default-footer
              no-data-text="-"
            >
              <template v-slot:[`item.product.supplierId`]="{ item }">
                <span v-if="item && item.product && item.product.supplierId">
                  {{ getSupplierName(item.product.supplierId) }}
                </span>
                <div v-else class="text-center">-</div>
              </template>
            </v-data-table>
          </template>

          <!-- 数量 -->
          <template v-slot:[`item.calculatedQuantity`]="{ item }">
            <v-data-table
              class="child-table"
              :headers="[{ value: 'quantity', align: 'end' }]"
              :items="item.relatedProductList"
              hide-default-header
              hide-default-footer
              no-data-text="-"
            >
              <template v-slot:[`item.quantity`]="{ item }">
                <span v-if="item && item.totalQuantity">
                  {{ item.totalQuantity }}
                </span>
                <div v-else class="text-center">-</div>
              </template>
            </v-data-table>
          </template>

          <!-- 登録単価 -->
          <template v-slot:[`item.price`]="{ item }">
            <v-data-table
              class="child-table"
              :headers="[{ value: 'price', align: 'end' }]"
              :items="item.relatedProductList"
              hide-default-header
              hide-default-footer
              no-data-text="-"
            >
              <template v-slot:[`item.price`]="{ item }">
                <span v-if="item && item.price">
                  {{ item.price }}
                </span>
                <div v-else class="text-center">-</div>
              </template>
            </v-data-table>
          </template>

          <!-- 割引 -->
          <template v-slot:[`item.discount`]="{ item }">
            <div v-if="getDiscountPrice(item)" class="text-right">
              {{ getDiscountPrice(item) }}
            </div>
            <div v-else class="text-center">-</div>
          </template>

          <!-- 送料・手数料 -->
          <template v-slot:[`item.postage`]="{ item }">
            <div class="text-right">
              {{ item.postage }}
            </div>
          </template>

          <!-- 合計金額 -->
          <template v-slot:[`item.amount`]="{ item }">
            {{ item.topayAmount }}
          </template>
        </v-data-table>
      </template>
      <template #footer>
        <v-container fluid>
          <v-row justify="end" class="ma-1">
            <NormalButton
              :text="$t('common.input_fix')"
              color="white"
              class="pr-5"
              textColor="thinText--text"
              height="50px"
              width="130px"
              @click="inputValue.dialog = false"
            />
            <NormalButton
              :text="$t('common.input_save')"
              height="50px"
              width="130px"
              @click="register"
            />
          </v-row>
        </v-container>
      </template>
    </MultipleAreaBase>
  </div>
</template>

<script>
import MultipleAreaBase from '@/components/layouts/Dialogs/MultipleArea/MultipleAreaBase'
import InputFormNew from '@/components/items/Designs/InputFormNew'
import { NormalButton } from '@/components/items'
import { mapGetters, mapActions } from 'vuex'
import { commonUtil, platformUtil } from '@/util'
import { i18n } from '@/main.js'
import { BigNumber } from 'bignumber.js'

export default {
  components: {
    MultipleAreaBase,
    InputFormNew,
    NormalButton
  },
  props: {
    value: { default: false },
    list: { default: [] },
    platformId: { default: '', required: true }
  },
  data: () => ({
    inputData: {
      saleDate: commonUtil.getToday(),
      customer: { value: 1, label: '中国EC' }
    },
    items: [
      {
        text: 'jd.jd_jdcom-store-name',
        name: 'platform'
      },
      {
        text: 'sale.sale_sale-date',
        name: 'saleDate',
        component: 'NormalDatePicker',
        required: true
      },
      {
        name: 'customer',
        text: 'sale.sale_customer',
        component: 'SelectCustomerName',
        required: true
      }
    ],
    inputFormStyle: {
      titleCols: 3,
      contentsCols: 7,
      inputItemHeight: '32px'
    },
    pageData: [
      {
        title: 'sale.sale_sale-register-info',
        name: 'saleInfo',
        items: [],
        itemKey: ''
      },
      {
        title: 'sale.sale_sales-registration-details',
        name: 'saleDetail',
        items: [],
        itemKey: ''
      }
    ],
    headers: [
      {
        text: i18n.tc('sale.sale_sale-number'),
        value: 'orderNumber',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('sale.sale_deliver-info'),
        value: 'customerInfo',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('sale.sale_sale-note'),
        value: 'orderNote',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('sale.sale_product-register-name'),
        value: 'jdproductName',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('product.product_supplier'),
        value: 'supplierName',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('common.common_product-quantity'),
        value: 'calculatedQuantity',
        sortable: false,
        align: 'center',
        width: '60'
      },
      {
        text: i18n.tc('jd.jd_jdcom-related-product-price'),
        value: 'price',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('common.input_discount-only'),
        value: 'discount',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('common.common_postage-commission'),
        value: 'postage',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('payment.payment_total-price-no-colon'),
        value: 'amount',
        sortable: false,
        align: 'center'
      }
    ]
  }),
  methods: {
    ...mapActions('Jdproduct', ['getJdproductListFromApi']),
    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapActions('FileStore', ['externalSystemCsvSave']),
    async register() {
      if (!this.inputData.customer) {
        alert(this.$t('common.common_customer-not-selected'))
        return
      }

      let isRegisted = false
      this.list.forEach((detail) => {
        if (detail.exCsvFileDetailOperationList.length > 0) {
          isRegisted = true
        }
      })
      let jdCsvFileDetailIdList
      if (isRegisted) {
        if (!confirm(this.$t('common.common_registed-sale-save-question'))) {
          return
        }
        jdCsvFileDetailIdList = this.list.map((ele) => {
          return ele.exCsvFileDetailId
        })
      } else {
        if (!confirm(this.$t('common.common_save-question'))) return
        jdCsvFileDetailIdList = this.list.map((ele) => {
          return ele.exCsvFileDetailId
        })
      }
      const isSuccess = await this.externalSystemCsvSave({
        saleDate: this.inputData.saleDate,
        customerId: this.inputData.customer.value,
        exCsvFileDetailIdList: jdCsvFileDetailIdList
      })
      if (!isSuccess) return
      alert(this.$t('common.common_saved-alert'))
      this.inputValue.dialog = false
    },
    getSupplierName(supplierId) {
      return this.getSupplier(supplierId)
        ? this.getSupplier(supplierId).name
        : ''
    },
    getDiscountPrice(item) {
      const relatedProductList = item.relatedProductList
      if (relatedProductList.some((product) => !product)) return ''

      const quantities = relatedProductList.map(
        (product) => product.totalQuantity
      )

      const prices = relatedProductList.map((product) => Number(product.price))
      const discountPrices = quantities.map(
        (quantity, index) => quantity * prices[index]
      )
      if (discountPrices.length > 0) {
        const discountPrice = discountPrices.reduce((a, x) => a + x)
        return item.topayAmount - discountPrice
      }
      return ''
    },
    getPlatformName() {
      return platformUtil.getPlatformById(this.platformId).name
    },
    async init() {
      await this.getJdproductListFromApi()
      await this.getSuppliersFromApi()
    },
    parentRowClass() {
      return 'parent-row'
    }
  },
  watch: {
    inputValue: {
      deep: true,
      async handler(newVal) {
        if (!newVal.dialog) return
        this.init()
      }
    }
  },
  computed: {
    ...mapGetters('Jdproduct', [
      'getJdproductListFromState',
      'getRelatedProductList'
    ]),
    ...mapGetters('Supplier', ['getSupplier']),
    combinedList() {
      const combinedList = []
      const list = JSON.parse(JSON.stringify(this.list)) // 参照を切る

      // 関連商品を紐付ける
      for (const item of list) {
        // 参照を切る
        item.relatedProductList = JSON.parse(
          JSON.stringify(
            this.getRelatedProductList(item.exProductNumber, this.platformId)
          )
        )
        if (item.relatedProductList.length <= 0) {
          item.relatedProductList.push(null)
        }

        // 数量を計算
        item.relatedProductList.forEach((relatedProduct) => {
          if (relatedProduct) {
            relatedProduct.totalQuantity =
              item.quantity * relatedProduct.quantity
          }
        })
      }

      // 注文番号ごとに結合する
      for (const item of list) {
        const sameOrderItem = combinedList.find(
          (combinedItem) => combinedItem.orderNumber === item.orderNumber
        )
        // 既に同じ注文番号が存在する場合
        if (sameOrderItem) {
          // 注文メモを連結する
          sameOrderItem.orderNote += item.orderNote ? `\n${item.orderNote}` : ''
          // 合計金額に加算する
          sameOrderItem.topayAmount = BigNumber(item.topayAmount)
            .plus(sameOrderItem.topayAmount)
            .toNumber()
          // 手数料に加算する
          sameOrderItem.postage = BigNumber(item.postage)
            .plus(sameOrderItem.postage)
            .toNumber()

          // 関連商品を追加する
          if (item.relatedProductList.length > 0) {
            item.relatedProductList.forEach((relatedProduct) => {
              sameOrderItem.relatedProductList.push(relatedProduct)
            })
          } else {
            sameOrderItem.relatedProductList.push(null)
          }

          continue
        }
        item.orderNote = item.orderNote || ''
        item.topayAmount = BigNumber(item.topayAmount).toNumber()
        item.postage = BigNumber(item.postage).toNumber()

        combinedList.push(item)
      }
      return combinedList
    },
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}

::v-deep .v-data-table-header {
  background-color: #97c6ea1a;

  th + th {
    border-left: 1px solid #ddd;
  }
}

::v-deep table td + td {
  border-left: 1px solid #ddd;
}

::v-deep .parent-row:nth-of-type(even) {
  background-color: #f6f6f6;
}

// 4~7列目(登録商品名、仕入先、数量、登録単価)はpadding: 0
::v-deep table td:nth-child(n + 4):nth-child(-n + 7) {
  padding: 0 !important;
}

::v-deep .v-data-table.child-table {
  background-color: transparent !important;
  pointer-events: none;
}
</style>
